
export class ServicePaths{
    constructor(){

    }
    
}